export default "__VITE_ASSET__CbQkD9zA__"